import React, {Fragment} from "react";
import PropTypes from "prop-types";

import {DISCOUNT_MAIN_TYPES, DISCOUNT_TYPES} from "../../priceWorksheet/discounstInterface";
import {getPriceWithCurrency, toFixedPrice} from "../../../misc/helpers";
import {
  calculateDeposit,
  getDiscountCurrentValue,
  getDiscountSubTotalPrice
} from "../../priceWorksheet/discountFunctions";
// import PrintDocumentDiscountFinance from "./printDocumentDiscountFinance";

const PrintDocumentDiscount = (props) => {
  const {styles, discount, priceWorksheetState, discountSection, fabricatorSettings, messages, hasMultipleWorkSheets,
    quoteIndex} = props;
  const {discountSections, customAddedDiscounts} = priceWorksheetState;

  const {View, Text} = window.ReactPdfRenderer;
  const realAmount = getDiscountCurrentValue(discount, "amount", quoteIndex, hasMultipleWorkSheets);
  const realType = getDiscountCurrentValue(discount, "type", quoteIndex, hasMultipleWorkSheets);
  const realApproveOptions = getDiscountCurrentValue(discount, "approveOptions", quoteIndex, hasMultipleWorkSheets);
  const realName = getDiscountCurrentValue(discount, "name", quoteIndex, hasMultipleWorkSheets);

  const getDiscountPercentageAmount = () => {
    const {discountSubTotal} = getDiscountSubTotalPrice(discountSections, discountSection, discount, true, customAddedDiscounts, quoteIndex, hasMultipleWorkSheets);
    const priceTaken = discountSubTotal * realAmount / 100 // for ex. 25% from 2700 = 625
    return toFixedPrice(Math.trunc(priceTaken * 100) / 100);
  };

  if (discount.discountType === DISCOUNT_MAIN_TYPES.deposit || discount.discountType === DISCOUNT_MAIN_TYPES.downPayment) {
    const amount = realType === DISCOUNT_TYPES.price
      ? realAmount
      : calculateDeposit(discountSections, discount, quoteIndex, hasMultipleWorkSheets);
    return (
      <View style={[styles.cartItemInfo, styles.discountDeposit]} wrap={false}>
        <Text style={styles.cartItemName}>{discount.name}</Text>
        <Text style={styles.cartItemPrice}>
          {getPriceWithCurrency(fabricatorSettings, amount)}
        </Text>
      </View>
    )
  }

  if (discount.discountType === DISCOUNT_MAIN_TYPES.finance) {
    // return <PrintDocumentDiscountFinance {...props}/>
    return null
  }

  const discountAmount = realType === DISCOUNT_TYPES.price
    ? "-" + getPriceWithCurrency(fabricatorSettings, toFixedPrice(realAmount))
    : "-" + getPriceWithCurrency(fabricatorSettings, getDiscountPercentageAmount());

  const approveOptions = realApproveOptions ? JSON.parse(realApproveOptions) : null;

  return (
    <View style={styles.cartItem} wrap={false}>
      <View style={styles.cartItemInfo}>
        <View style={[styles.flex, styles.flexRow, styles.flexCenter]}>
          <Text style={styles.cartItemName}>{realName}</Text>
          {approveOptions && approveOptions.selectedOption ? (
            <Fragment>
              <Text style={[styles.marginL20, styles.cartItemSimilarItemExample]}>{messages["receipt.discount.approvedBy"]}: </Text>
              <Text style={styles.cartItemName}>{approveOptions.selectedOption}</Text>
            </Fragment>
          ) : null}
        </View>
        <Text style={styles.cartItemPrice}>{discountAmount}</Text>
      </View>
    </View>
  )
};

PrintDocumentDiscount.propTypes = {
  discount: PropTypes.object.isRequired,
  priceWorksheetState: PropTypes.object.isRequired,
  discountSection: PropTypes.object.isRequired,
  fabricatorSettings: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired,
  grandTotal: PropTypes.number,
};

export default PrintDocumentDiscount
